import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { PageHeader, Empty } from "@/components/PageHeader";
import { Compass, Loader2, Star, MapPin, ArrowUpRight } from "lucide-react";

export default function Opportunities() {
  const navigate = useNavigate();
  const [jobs, setJobs] = useState(null);
  useEffect(() => { api.get("/jobs/published").then(({ data }) => setJobs(data)); }, []);
  return (
    <div>
      <PageHeader overline="Open & featured roles" title="Opportunities" />
      <div className="p-8">
        {!jobs && <div className="flex justify-center py-24"><Loader2 className="h-6 w-6 animate-spin text-muted-foreground" /></div>}
        {jobs && jobs.length === 0 && <Empty icon={Compass} title="No open roles right now" hint="New opportunities are posted regularly — check back soon." />}
        {jobs && jobs.length > 0 && (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-black/10 border border-black/10">
            {jobs.map((j) => (
              <button key={j.id} onClick={() => navigate(`/candidate/jobs/${j.id}`)} data-testid={`opp-${j.id}`}
                className="group bg-white p-6 text-left hover:bg-[#F1F1F3] transition-colors">
                <div className="flex items-start justify-between">
                  <span className="text-[0.6rem] font-mono uppercase tracking-wider text-muted-foreground">{j.role_category}</span>
                  {j.featured && <span className="flex items-center gap-1 text-[0.6rem] font-mono text-primary"><Star className="h-3 w-3 fill-primary" /> FEATURED</span>}
                </div>
                <h3 className="font-heading font-bold text-lg mt-3 group-hover:text-primary transition-colors">{j.title}</h3>
                <p className="text-sm text-muted-foreground">{j.organization_name}</p>
                {j.location && <p className="text-xs text-muted-foreground mt-2 flex items-center gap-1"><MapPin className="h-3 w-3" /> {j.location}</p>}
                <span className="mt-4 inline-flex items-center gap-1 text-sm text-primary group-hover:gap-2 transition-all">View role <ArrowUpRight className="h-3.5 w-3.5" /></span>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
